/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MonitEntityPrivacySignalsOrderBy = {
    EntityId: 'entity_id',
    Asset: 'asset',
    Found: 'found',
    Created: 'created',
    Updated: 'updated'
} as const;
export type MonitEntityPrivacySignalsOrderBy = typeof MonitEntityPrivacySignalsOrderBy[keyof typeof MonitEntityPrivacySignalsOrderBy];


export function MonitEntityPrivacySignalsOrderByFromJSON(json: any): MonitEntityPrivacySignalsOrderBy {
    return MonitEntityPrivacySignalsOrderByFromJSONTyped(json, false);
}

export function MonitEntityPrivacySignalsOrderByFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityPrivacySignalsOrderBy {
    return json as MonitEntityPrivacySignalsOrderBy;
}

export function MonitEntityPrivacySignalsOrderByToJSON(value?: MonitEntityPrivacySignalsOrderBy | null): any {
    return value as any;
}

